// extracted by mini-css-extract-plugin
export var accessibility_message = "a11yMessage-module--accessibility_message--4ab76";
export var accessibilty_message = "a11yMessage-module--accessibilty_message--dd217";
export var message = "a11yMessage-module--message--fe62c";